import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const AREAS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('AREAS');
export const AREAS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(AREAS_CRUD_ACTION_CONSTANTS);
